export const dashboardPtBR = {
  // compartilhado — DashboardNav
  'dashboard.nav.ariaLabel': 'Seções do painel',
  'dashboard.nav.overview': 'Visão geral',
  'dashboard.nav.avatar': 'Avatar',
  'dashboard.nav.coins': 'Moedas',
  'dashboard.nav.contributions': 'Contribuições',

  // compartilhado — StatusBadge (status de contribuição)
  'dashboard.status.draft': 'Rascunho',
  'dashboard.status.submitted': 'Enviado',
  'dashboard.status.communityReview': 'Revisão da comunidade',
  'dashboard.status.officialReview': 'Revisão oficial',
  'dashboard.status.approved': 'Aprovado',
  'dashboard.status.rejected': 'Rejeitado',
  'dashboard.status.unknown': 'desconhecido',

  // compartilhado — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'pendente',
  'dashboard.claimStatus.approved': 'aprovado',
  'dashboard.claimStatus.rejected': 'rejeitado',

  // DashboardPage
  'dashboard.seo.title': 'Meu Grymwyrd',
  'dashboard.seo.description': 'Suas moedas, reivindicações, contribuições e personagens no crepúsculo eterno.',
  'dashboard.displayNameFallback': 'Andarilho',
  'dashboard.welcomeBack': 'Bem-vindo de volta',
  'dashboard.editAvatar': 'Editar avatar',
  'dashboard.loading': 'Reunindo sua lenda…',
  'dashboard.avatarAlt': 'Retrato de {name}',
  'dashboard.offlineNotice':
    'Os dados do perfil em tempo real não estão disponíveis — mostrando sua última sessão conhecida e conteúdo de exemplo.',

  // DashboardPage — cartão de moedas
  'dashboard.coins.title': 'Moedas Sepulcrais',
  'dashboard.coins.viewAll': 'Ver tudo',
  'dashboard.coins.unit': 'moedas',
  'dashboard.coins.noActivity': 'Nenhuma atividade de moedas ainda.',
  'dashboard.coins.fullHistory': 'Histórico completo e comprar moedas',

  // DashboardPage — cartão de contribuições
  'dashboard.contributions.title': 'Contribuições',
  'dashboard.contributions.manage': 'Gerenciar',
  'dashboard.contributions.empty': 'Nenhuma contribuição ainda — escreva sua primeira.',

  // DashboardPage — cartão de reivindicações
  'dashboard.claims.title': 'Espaços mundiais reivindicados',
  'dashboard.claims.empty': 'Você ainda não controla nenhuma terra em Grymwyrd.',
  'dashboard.claims.kindClaimed': '{kind} · reivindicado em {date}',

  // DashboardPage — cartão de personagens
  'dashboard.characters.title': 'Personagens',
  'dashboard.characters.empty': 'Nenhuma alma ligada ao seu nome.',
  'dashboard.characters.level': 'Nv {level}',
  'dashboard.characters.unknown': 'Desconhecido',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Editor de Avatar',
  'dashboard.avatarEditor.seo.description': 'Molde o rosto que você mostra ao mundo de Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Editor de Avatar',
  'dashboard.avatarEditor.errorNotImage': 'Esse arquivo não é uma imagem.',
  'dashboard.avatarEditor.errorNameRequired': 'Um nome é obrigatório, mesmo na escuridão.',
  'dashboard.avatarEditor.portrait': 'Retrato',
  'dashboard.avatarEditor.portraitPreview': 'Visualização do retrato',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Visualização do avatar',
  'dashboard.avatarEditor.zoom': 'Zoom',
  'dashboard.avatarEditor.zoomAria': 'Ampliar retrato',
  'dashboard.avatarEditor.panHorizontal': 'Deslocar retrato na horizontal',
  'dashboard.avatarEditor.panVertical': 'Deslocar retrato na vertical',
  'dashboard.avatarEditor.uploadAria': 'Enviar imagem de retrato',
  'dashboard.avatarEditor.changeImage': 'Trocar imagem',
  'dashboard.avatarEditor.uploadImage': 'Enviar imagem',
  'dashboard.avatarEditor.identity': 'Identidade',
  'dashboard.avatarEditor.displayName': 'Nome de exibição',
  'dashboard.avatarEditor.backstory': 'Antecedentes',
  'dashboard.avatarEditor.backstoryPlaceholder': 'De onde você veio e que destino sombrio você busca?',
  'dashboard.avatarEditor.publicProfile': 'Perfil público',
  'dashboard.avatarEditor.publicVisible': 'Visível no Salão das Legendas.',
  'dashboard.avatarEditor.publicHidden': 'Oculto de outros andarilhos.',
  'dashboard.avatarEditor.saving': 'Salvando…',
  'dashboard.avatarEditor.saveChanges': 'Salvar mudanças',
  'dashboard.avatarEditor.saved': 'Salvo',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'O checkout ainda não está disponível — os cofres permanecem trancados.',
  'dashboard.coinHistory.notEnoughCoins': 'Moedas insuficientes para isso.',
  'dashboard.coinHistory.reasonWorldClaim': 'Reivindicação mundial',
  'dashboard.coinHistory.reasonCosmetic': 'Cosmético',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Gastos {cost} moedas em {name}.',
  'dashboard.coinHistory.seo.title': 'Moedas Sepulcrais',
  'dashboard.coinHistory.seo.description': 'Seu ledger completo de moedas, recargas e as mercadorias dos mortos.',
  'dashboard.coinHistory.heading': 'Moedas Sepulcrais',
  'dashboard.coinHistory.balance': 'saldo',
  'dashboard.coinHistory.buyCoins': 'Comprar moedas',
  'dashboard.coinHistory.packCoins': '{coins} moedas',
  'dashboard.coinHistory.packBonus': ' + {bonus} bônus',
  'dashboard.coinHistory.summoningCheckout': 'Invocando checkout…',
  'dashboard.coinHistory.purchase': 'Comprar',
  'dashboard.coinHistory.spendCoins': 'Gastar moedas',
  'dashboard.coinHistory.insufficientCoins': 'Moedas insuficientes',
  'dashboard.coinHistory.spending': 'Gastando…',
  'dashboard.coinHistory.spendAmount': 'Gastar {cost}',
  'dashboard.coinHistory.historyTitle': 'Histórico',
  'dashboard.coinHistory.tallyingLedger': 'Contabilizando o ledger…',
  'dashboard.coinHistory.tableCaption': 'Histórico de transações de moedas',
  'dashboard.coinHistory.colReason': 'Razão',
  'dashboard.coinHistory.colAmount': 'Valor',
  'dashboard.coinHistory.noTransactions': 'Nenhuma transação ainda.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'Minhas contribuições',
  'dashboard.contributionsPage.seo.description':
    'A lore que você escreveu e sua passagem pelo crivo dos moderadores.',
  'dashboard.contributionsPage.heading': 'Contribuições',
  'dashboard.contributionsPage.newContribution': 'Nova contribuição',
  'dashboard.contributionsPage.loading': 'Desenrolando seus pergaminhos…',
  'dashboard.contributionsPage.empty': 'Você ainda não escreveu lore. Comece sua primeira contribuição.',
  'dashboard.contributionsPage.untitledDraft': 'Rascunho sem título',
  'dashboard.contributionsPage.moderator': 'Moderador:',
  'dashboard.contributionsPage.entryFallback': 'Entrada',
  'dashboard.contributionsPage.errorNameRequired': 'Toda criação precisa de um nome.',
  'dashboard.contributionsPage.modalTitle': 'Nova contribuição',
  'dashboard.contributionsPage.type': 'Tipo',
  'dashboard.contributionsPage.titleLabel': 'Título',
  'dashboard.contributionsPage.summaryLabel': 'Resumo',
  'dashboard.contributionsPage.saveDraft': 'Salvar rascunho',
  'dashboard.contributionsPage.submitting': 'Enviando…',
  'dashboard.contributionsPage.submitForReview': 'Enviar para revisão',
}
